import { Container, Row, Column, Justify } from '@uds/grid';
import Colorway from '@uds/colorway';
import { Alignment } from 'domain/constants/alignment';

import { getClassNames } from './DomainSearchInput.stylesheet';
import DomainSearchTypeLockup from './DomainSearchTypeLockup';
import SearchInput from './SearchInput';
import {
  SearchInputConfigProps,
  DomainSearchTextProps,
  DomainSearchDesignProps,
  SearchInputCTAProps,
} from '../models/types';

export interface DomainSearchInputProps extends SearchInputConfigProps {
  text: DomainSearchTextProps;
  design: DomainSearchDesignProps;
  search: SearchInputCTAProps;
  isSticky: boolean;
  hBaseline?: number;
}

const DomainSearchInput = ({
  isSticky,
  colorway,
  disabled = false,
  prefix,
  search,
  text,
  design = {
    collapsePadding: {
      top: false,
      bottom: false,
    },
    alignment: Alignment.STARTING,
  },
  hBaseline,
}: DomainSearchInputProps) => {
  const classNames = getClassNames({ design });
  const { precursor, title, subtitle } = text;
  const rowAlign = design?.alignment === 'start' ? Justify.FLEX_START : Justify.CENTER;
  return (
    <div className={classNames.rootWrapper}>
      <div className={classNames.root}>
        <Colorway colorway={colorway}>
          <Container>
            <Row vblock={true} justify={rowAlign}>
              <Column xs={12} md={8} lg={6}>
                <div className={classNames.content}>
                  <DomainSearchTypeLockup
                    className={classNames.text}
                    title={title}
                    precursor={precursor}
                    subtitle={subtitle}
                    hBaseline={hBaseline}
                  />
                  <div className={classNames.searchInputWrapper} data-testid="domain-search-input">
                    <SearchInput
                      placeholder={search?.placeholder}
                      disabled={disabled}
                      glyph={search?.glyph}
                      tld={search?.tld}
                      label={search?.label}
                      prefix={prefix}
                      ariaHidden={isSticky}
                    />
                  </div>
                </div>
              </Column>
            </Row>
          </Container>
        </Colorway>
      </div>
    </div>
  );
};

export default DomainSearchInput;
